import { useState, type ReactNode } from 'react';
import {
  Button,
  IconButton,
  Badge,
  Avatar,
  Icon,
  Input,
  Select,
  SearchField,
  FilterChip,
  Switch,
  Card,
  StatCard,
  TransactionRow,
  ProgressBar,
  ProgressRing,
  Tabs,
  Modal,
} from '@getpay93/ui';

function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section style={{ marginBottom: 36 }}>
      <h2 style={{ fontSize: 13, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.08em', color: 'var(--text-hint)', marginBottom: 14 }}>{title}</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>{children}</div>
    </section>
  );
}

/** Kitchen-sink interno: verifica que los 20 componentes del design system rinden con tokens. */
export function KitchenSink() {
  const [modal, setModal] = useState(false);
  const [tab, setTab] = useState('todos');
  const [on, setOn] = useState(true);

  return (
    <div style={{ maxWidth: 960, margin: '0 auto', padding: '40px 24px 80px' }}>
      <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-.01em', color: 'var(--text-strong)', marginBottom: 4 }}>Kitchen Sink</h1>
      <p style={{ color: 'var(--text-faint)', marginTop: 0, marginBottom: 32, fontSize: 14 }}>@getpay93/ui — verificación visual del port del design system (W0).</p>

      <Section title="Buttons">
        <Button>Primary</Button>
        <Button variant="secondary">Secondary</Button>
        <Button variant="outline">Outline</Button>
        <Button variant="ghost">Ghost</Button>
        <Button variant="danger">Danger</Button>
        <Button iconLeft="plus">Con icono</Button>
        <Button disabled>Disabled</Button>
      </Section>

      <Section title="Icon buttons / Avatar / Icon">
        <IconButton icon="banknote" tone="green" label="Cobrar" />
        <IconButton icon="bell" tone="blue" label="Recordar" />
        <IconButton icon="link" label="Link" />
        <IconButton icon="trash-2" tone="red" label="Borrar" />
        <Avatar name="Andrés Coach" tone="solid" />
        <Avatar name="Fitness Quito" tone="green" size="sm" />
        <Icon name="layout-dashboard" />
        <Icon name="bar-chart-3" color="var(--brand-green)" />
      </Section>

      <Section title="Badges">
        <Badge tone="paid">Cobrado</Badge>
        <Badge tone="pending">Pendiente</Badge>
        <Badge tone="overdue">Vencido</Badge>
        <Badge tone="info">Info</Badge>
        <Badge tone="neutral">Neutral</Badge>
      </Section>

      <Section title="Forms">
        <div style={{ width: 240 }}>
          <Input label="Nombre" placeholder="Ana Pérez" />
        </div>
        <div style={{ width: 240 }}>
          <Select label="Vertical" options={['Coach', 'Gimnasio', 'Estudio', 'Tutoría', 'Nutrición']} />
        </div>
        <div style={{ width: 280 }}>
          <SearchField placeholder="Buscar cliente o plan…" />
        </div>
        <FilterChip label="Mes:" value="Octubre" />
        <FilterChip label="Estado:" value="Vencido" active />
        <Switch checked={on} onChange={setOn} label="Recordatorios" />
      </Section>

      <Section title="Data surfaces">
        <StatCard label="Total del mes" value="$12,450.00" tone="green" icon="banknote" />
        <StatCard label="Pendiente" value="$1,200.00" tone="amber" icon="clock" />
        <StatCard label="Vencido" value="$450.00" tone="red" icon="alert-triangle" />
        <ProgressRing value={72} max={100} label="Cobro" />
        <div style={{ width: 200 }}>
          <ProgressBar value={7} max={10} height={8} />
        </div>
      </Section>

      <Section title="Transaction row">
        <div style={{ width: 420 }}>
          <TransactionRow name="María González" plan="Plan Anual VIP" amount="$150.00" status="pending" dueDate="15 Oct 2025" />
        </div>
        <div style={{ width: 420 }}>
          <TransactionRow name="Luis Torres" plan="Mensual" amount="$45.00" status="overdue" overdueNote="HACE 3 DÍAS" />
        </div>
      </Section>

      <Section title="Tabs + Modal">
        <Tabs tabs={[{ id: 'todos', label: 'Todos' }, { id: 'pend', label: 'Pendientes', badge: 3 }, { id: 'pag', label: 'Pagados' }]} value={tab} onChange={setTab} />
        <Button onClick={() => setModal(true)}>Abrir modal</Button>
      </Section>

      <Card>
        <p style={{ margin: 0, color: 'var(--text-muted)' }}>Card genérica — superficie base slate-800.</p>
      </Card>

      <Modal
        open={modal}
        onClose={() => setModal(false)}
        title="Registrar pago"
        subtitle="Confirma el método y la fecha"
        footer={
          <>
            <Button variant="ghost" onClick={() => setModal(false)}>Cancelar</Button>
            <Button onClick={() => setModal(false)}>Registrar</Button>
          </>
        }
      >
        <p style={{ color: 'var(--text-muted)' }}>Contenido de ejemplo del diálogo.</p>
      </Modal>
    </div>
  );
}
